<ion-app>
  <div id="app-full-wrapper">
    <ion-router-outlet [class.router-outlet-ios]="currentPlatform === 'ios'"></ion-router-outlet>
  </div>
  <!-- <div *ngIf="loading" id="custom-web-splash" class="splash-container">
    <div class="splash-center-content">
      <img src="assets/images/logo.png" class="splash-icon" alt="App Icon" />
      <h1 class="splash-title">Community Sports Arenas</h1>
      <div class="splash-spinner"></div>
    </div>
    <p class="splash-version">Version {{ app_version }}</p>
  </div> -->
</ion-app>